var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPossible3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 70,
    viewBox: "0 0 46 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164138"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 163560"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148358",
    transform: "translate(32.542 18)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h11.192v13.227H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 163551"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148359",
    transform: "translate(32.507 41.401)",
    style: {
      fill: "#ffd133"
    },
    d: "M0 0h12.21v14.245H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148352",
    transform: "translate(3 18)",
    style: {
      fill: "#ffd133"
    },
    d: "M0 0h11.192v13.227H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148360",
    transform: "translate(32.507 40.401)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h11.192v13.227H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 44.918v-6.87h-8.9V15.353h-7.657v6.927H5.3V7.3h12.783v6.814H34.64V7.3h12.783v14.98H34.64v-6.927h-7.659v21.456h7.659v-6.927h12.783v15.036zM6.539 8.539zm29.34 22.582zm0-22.582zm0 12.5h10.306v-12.5H35.879zm0 22.639h10.306V31.121H35.879zM6.539 21.041h10.306V8.539H6.539z",
    transform: "translate(-3.3 9.7)",
    style: {
      fill: "#191919"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossible3);
export default __webpack_public_path__ + "static/media/possible-3.3c471f1e718d53667c62adeae16b589a.svg";
export { ForwardRef as ReactComponent };